// @ts-check
// Configurações > Atendimento (/settings/service-desk?tab=general|teams|hours|sla|categories|replies|identity|csat|retention;
// contrato 10 de atendimento, seção 24.4): Geral, Departamentos, Horários e calendário, Prazos, Categorias, Respostas
// prontas da escola e dos departamentos, Identificação, Avaliação e a aba Retenção da frente F5.
import { html } from 'htm/preact';
import { useEffect } from 'preact/hooks';
import { searchParamsState, updateSearchParams } from '../../app/router.js';
import { hasCurrentPermissionFlag } from '../../data/metadata-store.js';
import { PageCard, PageHeader } from '../page/page-card.js';
import { Icon } from '../../ui/icon.js';
import { RetentionSettingsTab } from '../retention/retention-settings-tab.js';
import { ServiceSettingsGeneralTab, ServiceSettingsIdentityTab, ServiceSettingsCsatTab } from './service-settings-general.js';
import { ServiceSettingsTeamsTab } from './service-settings-teams.js';
import { ServiceSettingsHoursTab } from './service-settings-hours.js';
import { ServiceSettingsCategoriesTab, ServiceSettingsSlaTab } from './service-settings-policies.js';
import { ReplyTemplatesManager } from './service-reply-templates.js';
import { t } from '../../i18n/index.js';

/** Abas da página, na ordem; a aba vem de ?tab= (padrão general). */
export const SERVICE_DESK_SETTINGS_TABS = Object.freeze(['general', 'teams', 'hours', 'sla', 'categories', 'replies', 'identity', 'csat', 'retention']);

/** Ícone de cada aba. */
const TAB_ICONS = Object.freeze(/** @type {Record<string, string>} */ ({
  general: 'IconSettings', teams: 'IconUsersGroup', hours: 'IconCalendar', sla: 'IconClock', categories: 'IconTag', replies: 'IconMessage', identity: 'IconId',
  csat: 'IconStar', retention: 'IconHeartHandshake',
}));

/** @param {string | null} value */
export function readSettingsTab(value) {
  return SERVICE_DESK_SETTINGS_TABS.includes(String(value)) ? String(value) : 'general';
}

export function ServiceDeskSettingsPage() {
  const tab = readSettingsTab(searchParamsState.value.get('tab'));
  const canEdit = hasCurrentPermissionFlag('SERVICE_DESK_SETTINGS');
  useEffect(() => {
    document.title = `${t('serviceDesk.screens.settings')} - ${t('navigation.settings')}`;
  }, []);
  return html`<${PageCard} className="service-screen service-settings-card" header=${html`<${PageHeader} icon="IconHeadset" title=${t('serviceDesk.screens.settings')} />`}>
    <div class="service-settings" data-testid="service-settings" data-tab=${tab}>
      <nav class="service-settings-tabs" role="tablist" aria-label=${t('serviceSettings.tabsLabel')}>
        ${SERVICE_DESK_SETTINGS_TABS.map((tabId) => html`<button key=${tabId} type="button" role="tab" class="service-settings-tab" aria-selected=${tab === tabId ? 'true' : 'false'}
          data-active=${tab === tabId ? 'true' : undefined} onClick=${() => updateSearchParams({ tab: tabId === 'general' ? null : tabId })}>
          <${Icon} name=${TAB_ICONS[tabId]} size=${16} /><span>${t(`serviceSettings.tabs.${tabId}`)}</span>
        </button>`)}
      </nav>
      <div class="settings-page service-settings-body">
        ${tab === 'general' ? html`<${ServiceSettingsGeneralTab} canEdit=${canEdit} />` : null}
        ${tab === 'teams' ? html`<${ServiceSettingsTeamsTab} canEdit=${canEdit} />` : null}
        ${tab === 'hours' ? html`<${ServiceSettingsHoursTab} canEdit=${canEdit} />` : null}
        ${tab === 'sla' ? html`<${ServiceSettingsSlaTab} canEdit=${canEdit} />` : null}
        ${tab === 'categories' ? html`<${ServiceSettingsCategoriesTab} canEdit=${canEdit} />` : null}
        ${tab === 'replies' ? html`<${ReplyTemplatesManager} scope="SCHOOL_AND_TEAM" canEdit=${canEdit} />` : null}
        ${tab === 'identity' ? html`<${ServiceSettingsIdentityTab} canEdit=${canEdit} />` : null}
        ${tab === 'csat' ? html`<${ServiceSettingsCsatTab} canEdit=${canEdit} />` : null}
        ${tab === 'retention' ? html`<${RetentionSettingsTab} canEdit=${canEdit} />` : null}
      </div>
    </div>
  <//>`;
}
